module.exports = {"330602001":"塔山街道","330602002":"府山街道","330602003":"蕺山街道","330602004":"北海街道","330602005":"城南街道","330602006":"稽山街道","330602007":"迪荡街道","330602008":"东湖街道","330602009":"灵芝街道","330602010":"东浦街道","330602011":"鉴湖街道","330602012":"斗门街道","330602104":"皋埠镇","330602105":"马山镇","330602107":"孙端镇","330602108":"富盛镇","330602109":"陶堰镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330602.json
// module id = 991
// module chunks = 0